import { render, staticRenderFns } from "./ModalCommSetting.vue?vue&type=template&id=86f373fa&scoped=true"
import script from "./ModalCommSetting.vue?vue&type=script&lang=js"
export * from "./ModalCommSetting.vue?vue&type=script&lang=js"
import style0 from "./ModalCommSetting.vue?vue&type=style&index=0&id=86f373fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f373fa",
  null
  
)

export default component.exports